import React from 'react';

export const SMS_CONSENT_LEGAL_TERMS = (
    <>
        I consent to Milan's info and promo emails, texts, and calls, which may be automated, prerecorded, or AI.
        Consent to contact is not a purchase condition. Frequency varies. Msg & data rates may apply. STOP to end. HELP
        for help.
    </>
);

export function ConsentMsg({
    cta = (
        <>
            Submit <sup>*</sup>
        </>
    ),
    legalTerms = (
        <>
            (affecting my rights) and consent to receive recurring promotional or informational calls, texts and/or
            emails, which may be automated or use prerecorded or artificial intelligence, from or on behalf of Milan
            Laser about its products and services. Consent to communications is not a condition of purchase, and you may
            reach us via phone at 833-667-2967. Message and data rates may apply. Text HELP for help and STOP to stop.
        </>
    ),
    separator = ' ',
}) {
    return (
        <small>
            By clicking {cta}, I agree to the{' '}
            <a
                href="https://milanlaser.com/privacy"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-underline fw-bold"
            >
                Privacy Policy
            </a>{' '}
            and{' '}
            <a
                href="https://milanlaser.com/terms"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-underline fw-bold"
            >
                Terms
            </a>
            {separator}
            {legalTerms}
        </small>
    );
}

// Replaces the SMS opt-in checkbox + ConsentMsg pair (WEBDEV-4145/4146/4150/4493): clicking the
// CTA is itself the opt-in, so forms rendering this derive their consent fields from CTA_CLICK_SMS_OPT_IN.
export function MarketingConsentMsg({ cta }) {
    const linkClassName = 'text-decoration-underline fw-bold';
    return (
        <small>
            By clicking {cta}, I agree to the{' '}
            <a href="https://milanlaser.com/privacy" target="_blank" rel="noreferrer" className={linkClassName}>
                Privacy Policy
            </a>
            ,{' '}
            <a href="https://milanlaser.com/terms" target="_blank" rel="noreferrer" className={linkClassName}>
                Mobile Terms
            </a>
            , and{' '}
            <a href="https://milanlaser.com/terms" target="_blank" rel="noreferrer" className={linkClassName}>
                Terms of Service
            </a>{' '}
            and consent to recurring promotional and service-related calls, emails, and texts from Milan Laser
            (including short code 64526, AI or automated texts). Consent to contact is not a purchase condition.
            Frequency varies. Msg&amp;data rates may apply. STOP to end. HELP for help.{' '}
            <a href="tel:18336672967" className={linkClassName}>
                1-833-667-2967
            </a>{' '}
            or email{' '}
            <a href="mailto:privacy@milanlaser.com" className={linkClassName}>
                privacy@milanlaser.com
            </a>{' '}
            for support.
        </small>
    );
}

export default ConsentMsg;
